export var KcasTokenVerificationFieldType;
(function (KcasTokenVerificationFieldType) {
    KcasTokenVerificationFieldType["SSN_LAST_4"] = "L4SSN";
    KcasTokenVerificationFieldType["DOB"] = "DOB";
})(KcasTokenVerificationFieldType || (KcasTokenVerificationFieldType = {}));
export var KcasTokenVerificationFieldKey;
(function (KcasTokenVerificationFieldKey) {
    KcasTokenVerificationFieldKey["SSN_LAST_4"] = "ssnLast4";
    KcasTokenVerificationFieldKey["DOB"] = "dob";
})(KcasTokenVerificationFieldKey || (KcasTokenVerificationFieldKey = {}));
